import React, { useContext,useRef } from "react";
import { useEffect, useState } from "react";
import Title from "../../Components/Title";
import MissingConsumer from "../../Components/MissingConsumer";
import * as Yup from "yup";
import {
  GetMenuAccess,
  GetUserGroupList,
  saveUserMenuAccessData,
  UserGroupMenuAccess,
} from "../../Services/UserGroupAccessService";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Grid,
  Backdrop,
  ListItemButton,
  List,
  Checkbox,
  Collapse,
  Typography,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  IconButton,
  TextField,
  ListItem,
  ListItemText,
  Pagination, // ← ADDED: For pagination controls
} from "@mui/material";
import { PreferencesContext } from "../../PreferencesContext";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import useMediaQuery from "@mui/material/useMediaQuery";
import SplashComponent from "../../Navigation/splash";
import AsyncSelect from "react-select/async";
import { Form, Formik } from "formik";
import LoadingButton from "@mui/lab/LoadingButton";
import { AlertType } from "../../shared/Modal/AlertType";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import { useNavigate } from "react-router-dom";
import ShortcutButton from "../../Components/ShortcutButton";
import { GetSupplierList } from "../../Services/SupplierService";
import { GetBuyerList } from "../../Services/BuyerService";
import { GetProductList } from "../../Services/CategoryProductService";
import { GetProductCompanyList } from "../../Services/ProductCompanyService"; 
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
const UserGroupAccessMenu: any = {
  userGroupAccessCollection: [],
};

export default function UserGroupAccess() {
  const initialUserGroupAccess: IUserGroupAccess = {
    code: "",
    displayOrder: 0,
    menuId: "",
    menuUrl: "",
    name: "",
    location: "",
    parentMenuCode: "",
    hasInsertAccess: false,
    hasUpdateAccess: false,
    hasViewAccess: false,
    hasImportAccess: false,
    hasExportAccess: false,
    hasDeleteAccess: false,
  };
  let navigate = useNavigate();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  console.log("FULL USER CONTEXT:", userContext);

  const phone = useMediaQuery("(max-width:799px)");
  const phone2 = useMediaQuery("(max-width:499px)");
  // const [opne,setOpen] = useState(false)
  const [isLoading, setLoading] = useState(false);
  const [resultData, setResultData] = useState(initialUserGroupAccess);

  const [parent, setParent] = useState();
  const [openCollapse, setOpenCollapse] = useState({});
  const [parentChecked, setParentChecked] = useState(false);
  const [icon, setIcon] = useState({});

  // NEW: track expand/collapse open-state + chevron icon for individual report rows (3rd level nesting)
  const [reportCollapse, setReportCollapse] = useState({});
  const [reportIcon, setReportIcon] = useState({});

  const [userGroupList, serUserGroupList] = useState([]);
  const [userGroup, setUserGroup] = useState({ id: 0, label: "" });
  const [isSubmitLoading, setSubmitLoading] = useState(false);

  // NEW: tab state for System Access / Buyer / Supplier / Product tabs
  const [accessTabValue, setAccessTabValue] = useState(0);

  // ===== PAGINATION STATE FOR POPUP (Like BuyerSave) ===== // ← ADDED
  const [selectPopupPage, setSelectPopupPage] = useState(1);
  const [selectPopupPageSize] = useState(20);
  const [selectPopupTotalCount, setSelectPopupTotalCount] = useState(0);
  const [selectPopupAllItems, setSelectPopupAllItems] = useState<any[]>([]);

  const handleAccessTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setAccessTabValue(newValue);
  };

  // NEW: holds the raw IDs returned from the backend for the currently loaded user group,
// used to (re)apply prefill once buyerList/supplierList/productList finish loading.
const [pendingSelectedBuyerIds, setPendingSelectedBuyerIds] = useState<any[]>([]);
const [pendingSelectedSupplierIds, setPendingSelectedSupplierIds] = useState<any[]>([]);
const [pendingSelectedProductIds, setPendingSelectedProductIds] = useState<any[]>([]);
const [pendingSelectedProductCompanyIds, setPendingSelectedProductCompanyIds] = useState<any[]>([]); 

  const [children, setChildren] = useState([
    {
      value: "suppliers",
      label: "Suppliers",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "buyers",
      label: "Buyers",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "productCategory",
      label: "Product Category",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "products",
      label: "Products",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "taxes",
      label: "Taxes",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "units",
      label: "Units",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "transporters",
      label: "Transporters",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "warehouses",
      label: "Warehouses",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
    {
      value: "areas",
      label: "Areas",
      checked: false,
      add: false,
      update: false,
      delete: false,
      import: false,
      export: false,
    },
  ]);
  const [isAllCollapsOpen, setIsAllCollapsOpen] = useState(true);
  const [readWrite, setReadWrite] = useState(Array(15).fill(false));
  const [fullControl, setFullControl] = useState(Array(15).fill(false));
  const [viewAccess, setViewAccess] = useState(Array(15).fill(false));
  const [updateProps, setUpdateProps] = useState<any>([]);
  const [userGroupAccessData, setUserGroupAccessData] = useState({});
  // Data Access states for Buyer, Supplier, Product
const [supplierList, setSupplierList] = useState([]);
const [buyerList, setBuyerList] = useState([]);
const [productList, setProductList] = useState([]);
const [productCompanyList, setProductCompanyList] = useState([]);
const [selectedSuppliers, setSelectedSuppliers] = useState([]);
const [selectedBuyers, setSelectedBuyers] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);
const [selectedProductCompanies, setSelectedProductCompanies] = useState([]);

  // NEW: state for the "+" button popup used to select Buyers / Suppliers / Products
  const [selectPopup, setSelectPopup] = useState<{
    open: boolean;
    type: "" | "buyer" | "supplier" | "product";
  }>({
    open: false,
    type: "",
  });
  const [selectPopupSearch, setSelectPopupSearch] = useState("");
  const [showSelectAllPrompt, setShowSelectAllPrompt] = useState(false);
  const [selectAllPromptItems, setSelectAllPromptItems] = useState<any[]>([]);
  const [stagedSelection, setStagedSelection] = useState<any[]>([]);
  const saveButtonRef = useRef(null);

  const userAccessValidationSchema = Yup.array().of(
    Yup.object().shape({
      menuId: Yup.number(),
      name: Yup.string(),
      menuUrl: Yup.string(),
      parentMenu: Yup.string(),
      hasDeleteAccess: Yup.boolean(),
      hasInsertAccess: Yup.boolean(),
      hasImportAccess: Yup.boolean(),
      hasExportAccess: Yup.boolean(),
      hasUpdateAccess: Yup.boolean(),
      hasViewAccess: Yup.boolean(),
    })
  );

  const [updateData, setUpdateData] = useState({
    ...initialUserGroupAccess,
  });

  interface IUserGroupAccess {
    code: string;
    displayOrder: number;
    menuId: string;
    menuUrl: string;
    name: string;
    location: string;
    parentMenuCode: string;
    hasInsertAccess: boolean;
    hasUpdateAccess: boolean;
    hasViewAccess: boolean;
    hasImportAccess: boolean;
    hasExportAccess: boolean;
    hasDeleteAccess: boolean;
  }

  const usersecondSchema = Yup.array().of(
    Yup.object().shape({
      menuId: Yup.string(),
      name: Yup.string(),
      menuUrl: Yup.string(),
      parentMenu: Yup.string(),

      child: Yup.array().of(
        Yup.object().shape({
          menuId: Yup.number(),
          name: Yup.string(),
          menuUrl: Yup.string(),
          parentMenu: Yup.string(),
          hasDeleteAccess: Yup.boolean(),
          hasInsertAccess: Yup.boolean(),
          hasImportAccess: Yup.boolean(),
          hasExportAccess: Yup.boolean(),
          hasUpdateAccess: Yup.boolean(),
          hasViewAccess: Yup.boolean(),
        })
      ),
    })
  );

  const handleParantChange = (e: any, parentData: any) => {
    const isChecked = e.target.checked;
    setParentChecked(isChecked);

    const updatedChild = resultData?.filter(
      (childData: any) =>
        childData.parentMenuCode !== "" &&
        parentData.code === childData.parentMenuCode
    );
    // const updatedChild2 = updatedChild.filter((key) => key == "hasDeleteAccess" && key == "hasExportAccess" && key == "hasImportccess" && key == "hasInsertAccess" && key == "hasUpdateAccess" && key == "hasViewAccess")

    const updatedChild2 = updatedChild.map((obj) => {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([key, value]) => typeof value === "boolean" || key === "displayOrder"
        )
      );
    });

    // const updatedChild2 = updatedChild.filter((item) => console.log(item))
    // console.log("updatedChild2", updatedChild2);

    // const updatedChild = children.map((item) => ({
    //   ...item,
    //   checked: isChecked,
    //   add: isChecked,
    //   update: isChecked,
    //   delete: isChecked,
    //   import: isChecked,
    //   export: isChecked,
    // }));
    // setChildren(updatedChild);
  };

  const handleAllSelect = () => {
    const allOpenCollapses = {};

    for (let i = 0; i < 15; i++) {
      allOpenCollapses[i] = isAllCollapsOpen;
    }
    setIsAllCollapsOpen(!isAllCollapsOpen);
    setOpenCollapse(allOpenCollapses);

    // NEW: also open/close every individual report row (3rd level) together with the
    // top-level Expand/Collapse button, so pressing it expands the reports AND their sub-items.
    if (parent !== undefined) {
      const allReportCollapses = {};
      const allReportIcons = {};

      parent.forEach((pItem: any, mainIndex: number) => {
        resultData
          .filter((child: any) => child.parentMenuCode === pItem.code)
          .forEach((child: any) => {
            const hasSubItems = resultData.some(
              (v: any) => v.parentMenuCode === child.code
            );
            if (hasSubItems) {
              const key = `${mainIndex}-${child.code}`;
              allReportCollapses[key] = isAllCollapsOpen;
              allReportIcons[key] = isAllCollapsOpen;
            }
          });
      });

      setReportCollapse(allReportCollapses);
      setReportIcon(allReportIcons);
    }
  };

  const handleChildchange = (e, index) => {
    const ischecked = e.target.checked;
    const updatechildren = [...children];
    updatechildren[index].checked = ischecked;
    setChildren(updatechildren);

    setParentChecked(updatechildren.every((child) => child.checked));

    const child = updatechildren[index];
    const value = child.checked;
    const allTrue = Object.keys(child)
      .filter((key) => key !== "value" && key !== "label" && key !== "checked")
      .forEach((key) => (child[key] = value));

    setChildren(updatechildren);
  };

  const handlePropsChange = (
    e,
    index,
    items: string,
    parentMenuCode,
    parentMainIndex
  ) => {
    const ischecked = e.target.checked;
    const updatedItem = [...resultData];
    updatedItem[index][items] = ischecked;
    // setResultData(updatedItem);

    if (updatedItem[index][items] === true) {
      updatedItem[index].hasViewAccess = true;
      // setResultData(updatedItem)
    }
    if (!updatedItem[index].hasViewAccess) {
      [
        "hasDeleteAccess",
        "hasExportAccess",
        "hasImportAccess",
        "hasInsertAccess",
        "hasUpdateAccess",
      ].forEach((access) => {
        updatedItem[index][access] = false;
      });
    }
    setResultData(updatedItem);

    const filterChildMenu = resultData.filter(
      (item) => item.parentMenuCode === parentMenuCode
    );
    //set the value of true if all view are true (ViewAcces)
    const isViewAccessAlltrue = filterChildMenu.every(
      (item) => item.hasViewAccess === true
    );
    const tempViewAccess = [...viewAccess];
    tempViewAccess[parentMainIndex] = isViewAccessAlltrue;
    setViewAccess(tempViewAccess);

    //set the value of true if all view are true (Read Write)
    const isReadWriteAllTrue = filterChildMenu.every(
      (item) =>
        item.hasViewAccess === true &&
        item.hasInsertAccess === true &&
        item.hasUpdateAccess === true
    );
    const tempReadWrite = [...readWrite];
    tempReadWrite[parentMainIndex] = isReadWriteAllTrue;
    setReadWrite(tempReadWrite);

    //set the value of true if all view are true (fullcontroll)
    const isFullControlAllTrue = filterChildMenu.every(
      (item) =>
        item.hasViewAccess === true &&
        item.hasInsertAccess === true &&
        item.hasUpdateAccess === true &&
        item.hasDeleteAccess === true &&
        item.hasImportAccess === true &&
        item.hasExportAccess === true
    );

    const tempfullControl = [...fullControl];
    tempfullControl[parentMainIndex] = isFullControlAllTrue;
    setFullControl(tempfullControl);
  };

  function handleViewAccessOnly(event: any, code: string, mainIndex) {
    const ischecked = event.target.checked;
    const updatedItem = [...resultData];

    //for the changing value of the ViewAccess CheckBox
    const ViewcontrollCheckBox = [...viewAccess];
    ViewcontrollCheckBox[mainIndex] = !ViewcontrollCheckBox[mainIndex];
    setViewAccess(ViewcontrollCheckBox);

    // let filterdata = resultData.filter(
    //   (item, index) =>
    //     item.parentMenuCode === code &&
    //     (updatedItem[index].hasViewAccess = ischecked)
    // );

    let filterdata = resultData.filter(
      (item: any, index: any) =>
        (item.code === code || item.parentMenuCode === code) &&
        (updatedItem[index].hasViewAccess = ischecked)
    );
    setResultData(updatedItem);
  }

  function handleFullControl(event: any, code: string, mainIndex) {
    //for the changing value of the FullControll CheckBox
    const fullcontrolCheckBox = [...fullControl];
    fullcontrolCheckBox[mainIndex] = !fullcontrolCheckBox[mainIndex];
    setFullControl(fullcontrolCheckBox);

    //for the changing value of the ViewAccess CheckBox
    // const ViewcontrollCheckBox = [...viewAccess];
    // ViewcontrollCheckBox[mainIndex] = !ViewcontrollCheckBox[mainIndex];
    // setViewAccess(ViewcontrollCheckBox);

    const newCheckboxes = [...readWrite];
    newCheckboxes[mainIndex] = newCheckboxes[mainIndex]
      ? newCheckboxes[mainIndex]
      : !newCheckboxes[mainIndex];

    if (newCheckboxes[mainIndex] && !fullcontrolCheckBox[mainIndex]) {
      newCheckboxes[mainIndex] = !newCheckboxes[mainIndex];
    }
    setReadWrite(newCheckboxes);
    setViewAccess(newCheckboxes); //for the changing value of the ViewAccess CheckBox\
    setFullControl(newCheckboxes);

    const ischecked = event.target.checked;
    const updatedItem = [...resultData];

    let filtrateData = resultData.filter(
      (item: any, index: any) =>
        (item.code === code || item.parentMenuCode === code) &&
        ((updatedItem[index].hasImportAccess = ischecked),
          (updatedItem[index].hasDeleteAccess = ischecked),
          (updatedItem[index].hasExportAccess = ischecked),
          (updatedItem[index].hasInsertAccess = ischecked),
          (updatedItem[index].hasUpdateAccess = ischecked),
          (updatedItem[index].hasViewAccess = ischecked))
    );
    setResultData(updatedItem);
  }

  function handleReadWriteOnly(event: any, code: string, mainIndex) {
    const fullcontrolCheckBox = [...fullControl];
    fullcontrolCheckBox[mainIndex] =
      fullcontrolCheckBox[mainIndex] && !fullcontrolCheckBox[mainIndex];
    setFullControl(fullcontrolCheckBox);

    //for the changing value of the ReadWrite CheckBox
    const newCheckboxes = [...readWrite];
    newCheckboxes[mainIndex] = !newCheckboxes[mainIndex];

    setReadWrite(newCheckboxes);
    setViewAccess(newCheckboxes);

    //for the changing value of the ViewAccess CheckBox
    // const ViewcontrollCheckBox = [...viewAccess];
    // ViewcontrollCheckBox[mainIndex] = !ViewcontrollCheckBox[mainIndex];
    // setViewAccess(ViewcontrollCheckBox);

    //chane the all Child value
    const ischecked = event.target.checked;
    const updatedItem = [...resultData];

    // let filterdata = resultData.filter(
    //   (item, index) =>
    //     item.parentMenuCode === code &&
    //     ((updatedItem[index].hasInsertAccess = ischecked),
    //       (updatedItem[index].hasUpdateAccess = ischecked),
    //       (updatedItem[index].hasViewAccess = ischecked),
    //       (updatedItem[index].hasDeleteAccess = false), //false the others item like delete
    //       (updatedItem[index].hasImportccess = false), //false the others item like Import
    //       (updatedItem[index].hasExportAccess = false)) //false the others item like Export
    // );

    let filterdata = resultData.filter(
      (item: any, index: any) =>
        (item.code === code || item.parentMenuCode === code) &&
        ((updatedItem[index].hasInsertAccess = ischecked),
          (updatedItem[index].hasUpdateAccess = ischecked),
          (updatedItem[index].hasViewAccess = ischecked),
          (updatedItem[index].hasDeleteAccess = false), //false the others item like delete
          (updatedItem[index].hasImportAccess = false), //false the others item like Import
          (updatedItem[index].hasExportAccess = false)) //false the others item like Export
    );
    setResultData(updatedItem);
  }

  const handleToggleCollapse = (mainIndex: any) => {
    //collaps
    setOpenCollapse((prestate) => ({
      ...prestate,
      [mainIndex]: !prestate[mainIndex],
    }));

    //change icons accroding the collaps
    setIcon((prestate) => ({
      ...prestate,
      [mainIndex]: !prestate[mainIndex],
    }));
  };

  // NEW: toggles expand/collapse for one individual report row (3rd level nesting).
  // `key` is a unique identifier for that row, e.g. `${mainIndex}-${child.code}`
  const handleToggleReportCollapse = (key: any) => {
    setReportCollapse((prestate) => ({
      ...prestate,
      [key]: !prestate[key],
    }));

    setReportIcon((prestate) => ({
      ...prestate,
      [key]: !prestate[key],
    }));
  };

  // const FetchUserGroupMenu = async () => {
  //   try {
  //     setLoading(true);

  //     let param = new URLSearchParams();

  //     param.append("consumerId", userContext.consumerId.toString());
  //     param.append("firmId", userContext.firmId.toString());
  //     param.append("branchId", userContext.branchId.toString());
  //     param.append("userKey", userContext.userKey.toString());

  //     const result: any = await GetUserAccess(param);

  //     if (result) {
  //       let userGroupAccessMenu = result.data.data.userGroupAccessCollection;

  //       setResultData(userGroupAccessMenu);

  //       const ParantMenu = userGroupAccessMenu.filter(
  //         (item) => item.parentMenuCode === ""
  //       );
  //       setParent(ParantMenu);

  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };

  async function FetchGetMenuAccess() {
    try {
      let params = new URLSearchParams();

      params.append("consumerId", "1");
      params.append("firmId", "1");

      const result: any = await GetMenuAccess(params);
      if (result) {
        let menuAccessCollection = result.data.data.getMenuAccessCollection;

        setResultData(menuAccessCollection);

        const ParantMenu = menuAccessCollection.filter(
          (item: any) => item.parentMenuCode === ""
        );
        setParent(ParantMenu);
      }
    } catch (error) { }
  }

  async function FetchUserGroupMenuAccessList() {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("userGroupId", userGroup.id.toString());

      const result: any = await UserGroupMenuAccess(params);
      if (
        result !== undefined &&
        result !== null &&
        result.data !== undefined &&
        result.data.data !== undefined &&
        result.data.data.getMenuAccessCollection !== undefined &&
        result.data.data.getMenuAccessCollection !== null
      ) {
        let menuAccessCollection = result.data.data.getMenuAccessCollection;
        setResultData(menuAccessCollection);

        const ParantMenu = menuAccessCollection.filter(
          (item: any) => item.parentMenuCode === ""
        );
        setParent(ParantMenu);

        // ===== ADDED: capture selected buyer/supplier/product IDs for prefill =====
        setPendingSelectedBuyerIds(result.data.data.selectedBuyers || []);
        setPendingSelectedSupplierIds(result.data.data.selectedSuppliers || []);
        setPendingSelectedProductIds(result.data.data.selectedProducts || []);
        setPendingSelectedProductCompanyIds(result.data.data.selectedProductCompanies || []);

        // const updatedItem = [...menuAccessCollection];

        // let filterdata = menuAccessCollection.filter(
        //   (item: any, index: any) =>
        //   ((updatedItem[index].hasInsertAccess = item.hasInsertAccess),
        //     (updatedItem[index].hasUpdateAccess = item.hasUpdateAccess),
        //     (updatedItem[index].hasViewAccess = item.hasViewAccess),
        //     (updatedItem[index].hasDeleteAccess = item.hasDeleteAccess), //false the others item like delete
        //     (updatedItem[index].hasImportAccess = item.hasImportAccess), //false the others item like Import
        //     (updatedItem[index].hasExportAccess = item.hasExportAccess)) //false the others item like Export
        // );
        // setResultData(filterdata);
      }
    } catch (e: any) {
      // updateUserContext({
      //   ...userContext,
      //   isAlert: true,
      //   alertMessage:
      //     typeof e === "string" ? (e as string) : (e?.message as string),
      //   alertType: AlertType.Error,
      // });
    }
  }
// ===== FETCH SUPPLIERS =====
async function fetchSuppliers() {
  try {
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", "1");
    params.append("pageSize", "1000");
    const result: any = await GetSupplierList(params.toString());
    if (result && result.data && result.data.data) {
      const suppliers = result.data.data.supplierCollection || result.data.data || [];
      setSupplierList(
        suppliers.map((item: any) => ({
          value: item.supplierId || item.id,
          label: item.supplierName || item.name || "Unknown",
          ...item,
        }))
      );
    }
  } catch (error) {
    console.error("Error fetching suppliers:", error);
  }
}

// ===== FETCH BUYERS =====
async function fetchBuyers() {
  try {
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", "1");
    params.append("pageSize", "1000");
    const result: any = await GetBuyerList(params.toString());
    if (result && result.data && result.data.data) {
      const buyers = result.data.data.buyerCollection || result.data.data || [];
      setBuyerList(
        buyers.map((item: any) => ({
          value: item.buyerId || item.id,
          label: item.buyerName || item.name || "Unknown",
          ...item,
        }))
      );
    }
  } catch (error) {
    console.error("Error fetching buyers:", error);
  }
}

// ===== FETCH PRODUCTS =====
async function fetchProducts() {
  try {
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", "1");
    params.append("pageSize", "1000");
    params.append("financialYear", userContext.financialYear.toString());
    params.append("mode", "");
    const result: any = await GetProductList(params.toString());
    if (result && result.data && result.data.data) {
      const products = result.data.data.productCollection || result.data.data || [];
      setProductList(
        products.map((item: any) => ({
          value: item.productId || item.id,
          label: item.productName || item.name || "Unknown",
          ...item,
        }))
      );
    }
  } catch (error) {
    console.error("Error fetching products:", error);
  }
}
// ===== FETCH PRODUCT COMPANIES =====
async function fetchProductCompanies() {
  try {
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", "1");
    params.append("pageSize", "1000");
    params.append("mode", "ALL");  // Get all product companies
    const result: any = await GetProductCompanyList(params);
    if (result && result.data && result.data.data) {
      const companies = result.data.data.productCompanyCollection || result.data.data || [];
      setProductCompanyList(
        companies.map((item: any) => ({
          value: item.productCompanyId || item.product_company_id || item.id,
          label: item.productCompanyName || item.name || "Unknown",
          ...item,
        }))
      );
    }
  } catch (error) {
    console.error("Error fetching product companies:", error);
  }
}

const handleSupplierChange = (selected: any) => {
  setSelectedSuppliers(selected || []);
};

const handleBuyerChange = (selected: any) => {
  setSelectedBuyers(selected || []);
};

const handleProductChange = (selected: any) => {
  setSelectedProducts(selected || []);
};
const handleProductCompanyChange = (selected: any) => {
  setSelectedProductCompanies(selected || []);
};

  // NEW: helpers for the "+" button popup selector shared by Buyer / Supplier / Product tabs
  const getPopupConfig = (type: string) => {
    switch (type) {
      case "buyer":
        return {
          source: buyerList,
          selected: selectedBuyers,
          setSelected: setSelectedBuyers,
          title: "Select Buyers",
          allItems: buyerList, // ← ADDED: For pagination
        };
      case "supplier":
        return {
          source: supplierList,
          selected: selectedSuppliers,
          setSelected: setSelectedSuppliers,
          title: "Select Suppliers",
          allItems: supplierList, // ← ADDED: For pagination
        };
      case "product":
        return {
          source: productList,
          selected: selectedProducts,
          setSelected: setSelectedProducts,
          title: "Select Products",
          allItems: productList, // ← ADDED: For pagination
        };
         case "productCompany":  // ⭐ ADD THIS
      return {
        source: productCompanyList,
        selected: selectedProductCompanies,
        setSelected: setSelectedProductCompanies,
        title: "Select Product Companies",
        allItems: productCompanyList,
      };
      default:
        return { source: [], selected: [], setSelected: () => {}, title: "", allItems: [] };
    }
  };

  const handleOpenSelectPopup = (type: "buyer" | "supplier" | "product") => {
    const { selected, allItems } = getPopupConfig(type); // ← UPDATED: Added allItems
    setStagedSelection([...selected]);
    setSelectPopupSearch("");
    setSelectPopupPage(1); // ← ADDED: Reset to first page
    setSelectPopupAllItems(allItems || []); // ← ADDED
    setSelectPopupTotalCount(allItems?.length || 0); // ← ADDED
    setSelectPopup({ open: true, type });
  };

  const handleCloseSelectPopup = () => {
    setSelectPopup({ open: false, type: "" });
    setStagedSelection([]);
    setSelectPopupSearch("");
    if (document.activeElement) {
    document.activeElement.blur();
  }

  };

  const handleToggleSelectItem = (item: any) => {
    const exists = stagedSelection.some((x) => x.value === item.value);
    setStagedSelection(
      exists
        ? stagedSelection.filter((x) => x.value !== item.value)
        : [...stagedSelection, item]
    );
  };

  const handleSelectAllInPopup = (
  filteredList: any[],
  checked: boolean,
  allFilteredItems: any[]
) => {
  if (checked) {
    // Select only current page
    const newOnes = filteredList.filter(
      (item) =>
        !stagedSelection.some((x) => x.value === item.value)
    );

    setStagedSelection([
      ...stagedSelection,
      ...newOnes,
    ]);

    // Show Gmail-style Select All message
    if (allFilteredItems.length > filteredList.length) {
      setSelectAllPromptItems(allFilteredItems);
      setShowSelectAllPrompt(true);
    }
  } else {
    // Unselect only current page
    const pageValues = new Set(
      filteredList.map((x) => x.value)
    );

    setStagedSelection(
      stagedSelection.filter(
        (x) => !pageValues.has(x.value)
      )
    );

    setShowSelectAllPrompt(false);
    setSelectAllPromptItems([]);
  }
};

  const handleSaveSelectPopup = () => {
    const { setSelected } = getPopupConfig(selectPopup.type);
    setSelected([...stagedSelection]);
    handleCloseSelectPopup();
  };

  const handleRemoveSelectedItem = (
    type: "buyer" | "supplier" | "product"| "productCompany",
    item: any
  ) => {
    const { selected, setSelected } = getPopupConfig(type);
    setSelected(selected.filter((x: any) => x.value !== item.value));
  };

  const handlePropsUpdate = (
    dorder: any,
    mId: any,
    ky: any,
    e: any,
    parentMenuCode: any,
    code: any,
    childName: any //child name
  ) => {
    // updateProps.map((item: any, index) => {
    //   if (item.menuId == mId && item.key == ky) {
    //     setUpdateProps((prevItems) => {
    //       if (index !== -1) {
    //         return [
    //           ...prevItems.slice(0, index),
    //           ...prevItems.slice(index + 1),
    //         ];
    //       }
    //     });
    //   }
    // });

    setUpdateProps((preState) => {
      // const parentIndex = preState.findIndex((p) => p.parent == code)
      // if(parentIndex !== -1){
      //   alert();
      //   return [{ parent: code, child: [childName] }];
      // }
      // else{
      //   return [...preState,{ parent: code, child: [childName] }];
      // }
      // if (preState.length == 0) {
      //   alert();
      //   return [{ parent: code, child: [childName] }];
      // }
      //  else {
      //   preState.map((item, index) => {
      //     if (item.parent == code) {
      //       const indexItem = { ...preState[index] };
      //       indexItem.child.push(childName);
      //     }
      //     else{
      //       return [{ parent: code, child: [childName] }];
      //     }
      //   });
      //   // preState.push({ parent: code, child: childName });
      //   return preState;
      // }
    });

    // updateProps.push({

    // })

    // updateProps.push({
    //   displayOrder: dorder,
    //   menuId: mId,
    //   key: ky,
    //   value: e.target.checked,
    // });
  };

  const handleChangeUserGroup = (object: any) => {
    // FetchUserGroupMenu();
    setUserGroup({ id: object.userGroupId, label: object.label });
    FetchUserGroupList(object?.userGroupId || 0);
  };

  async function FetchUserGroupList(userGroupId: number = 0) {
    setLoading(true);
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("userGroupId", userGroupId?.toString());
      const result: any = await GetUserGroupList(params);
      if (result && result.data.data) {
        serUserGroupList(result.data.data.userGroupAccessCollection);
      }
      setLoading(false);
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
    setLoading(false);
  }

  async function SubmitUserAccess(value: any) {
    setSubmitLoading(true);
    const menuAccessData = value;
    const formData = new FormData();
    formData.append("consumerId", userContext.consumerId.toString());
    formData.append("firmId", userContext.firmId.toString());
    formData.append("branchId", userContext.branchId.toString());
    formData.append("userGroupId", userGroup.id.toString());
    formData.append("dataManagedBy", userContext.userId.toString());
    formData.append("menuAccessData", JSON.stringify(menuAccessData));
    formData.append("selectedSuppliers",JSON.stringify(selectedSuppliers.map((s: any) => s.value)));
    formData.append("selectedBuyers",JSON.stringify(selectedBuyers.map((b: any) => b.value)));
    formData.append("selectedProducts",JSON.stringify(selectedProducts.map((p: any) => p.value)));
    formData.append("selectedProductCompanies", JSON.stringify(selectedProductCompanies.map((pc: any) => pc.value)));
    try {
      // const resultVaccineSave: any = await CreateVaccine(formData);
      const userAccess: any = await saveUserMenuAccessData(formData);

      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: userAccess.message,
        alertType: AlertType.Success,
      });
      setSubmitLoading(false);
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  // ===== COMBINED KEYBOARD SHORTCUTS (Like BuyerSave) =====
useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    // If popup is open, handle popup shortcuts
    if (selectPopup.open) {
      // ESC key - Close popup
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        handleCloseSelectPopup();
        return;
      }
      
      // F10 key - Save selection
    if (event.key === "F10") {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  // Click the Save button programmatically
  if (saveButtonRef.current) {
    saveButtonRef.current.click();
  }
  return;
}
    }

    // If popup is closed, handle ESC for navigation
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      navigate(-1);
    }
  };

  window.addEventListener("keydown", handleKeyDown, true);
  return () => {
    window.removeEventListener("keydown", handleKeyDown, true);
  };
}, [navigate, selectPopup.open]);

  useEffect(() => {
    FetchUserGroupList();
    // FetchGetMenuAccess();
  }, []);

  useEffect(() => {
    if (userGroup.id > 0) {
      FetchUserGroupMenuAccessList();
      fetchSuppliers();
    fetchBuyers();
    fetchProducts();
    fetchProductCompanies();
    }
  }, [userGroup.id]);

    // NEW: reconcile prefill once buyerList/supplierList/productList have loaded
  // (fixes the race condition where GetUserGroupMenuAccess and Buyer/Supplier/Product
  // GetList calls fire in parallel — whichever finishes last triggers the match here)
  useEffect(() => {
    if (pendingSelectedBuyerIds.length > 0 && buyerList.length > 0) {
      setSelectedBuyers(
        buyerList.filter((item: any) =>
          pendingSelectedBuyerIds.some((id: any) => id?.toString() === item.value?.toString())
        )
      );
    } else if (pendingSelectedBuyerIds.length === 0) {
      setSelectedBuyers([]);
    }
  }, [pendingSelectedBuyerIds, buyerList]);

  useEffect(() => {
    if (pendingSelectedSupplierIds.length > 0 && supplierList.length > 0) {
      setSelectedSuppliers(
        supplierList.filter((item: any) =>
          pendingSelectedSupplierIds.some((id: any) => id?.toString() === item.value?.toString())
        )
      );
    } else if (pendingSelectedSupplierIds.length === 0) {
      setSelectedSuppliers([]);
    }
  }, [pendingSelectedSupplierIds, supplierList]);

  useEffect(() => {
    if (pendingSelectedProductIds.length > 0 && productList.length > 0) {
      setSelectedProducts(
        productList.filter((item: any) =>
          pendingSelectedProductIds.some((id: any) => id?.toString() === item.value?.toString())
        )
      );
    } else if (pendingSelectedProductIds.length === 0) {
      setSelectedProducts([]);
    }
  }, [pendingSelectedProductIds, productList]);

  useEffect(() => {
  if (pendingSelectedProductCompanyIds.length > 0 && productCompanyList.length > 0) {
    setSelectedProductCompanies(
      productCompanyList.filter((item: any) =>
        pendingSelectedProductCompanyIds.some((id: any) => id?.toString() === item.value?.toString())
      )
    );
  } else if (pendingSelectedProductCompanyIds.length === 0) {
    setSelectedProductCompanies([]);
  }
}, [pendingSelectedProductCompanyIds, productCompanyList]);

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          background: "#fff",
        }}
        open={isLoading}
      >
        <SplashComponent />
      </Backdrop>
      <Title pageTitle="User Group Access" />
      <Formik
        enableReinitialize
        initialValues={resultData}
        validationSchema={userAccessValidationSchema}
        onSubmit={(values) => {
          SubmitUserAccess(values);
        }}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Box
              className="boxContainer"
              sx={{
                "& > :not(style)": {
                  width: "100%",
                },
              }}
            >
              {userContext.consumerId > 0 ? (
                <Grid>
                  <Grid
                    className="title-button-responsive"
                    item
                    xs={6}
                    md={3}
                    sx={{
                      display: "flex !important",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h4 className="page-title">
                      User Group Access{" "}
                      {userGroup !== undefined &&
                        userGroup.label !== "" &&
                        "-" + userGroup.label.toUpperCase()}
                    </h4>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", ml: "auto" }}>
                      <Button
                        variant="outlined"
                        onClick={() => navigate("/dashboard")}
                        size="medium">
                        <ShortcutButton label="ESC" />
                        Back
                      </Button>
                    </Box>

                    <Grid
                      item
                      xs={6}
                      md={3}
                      marginRight={0}
                      textAlign="end"
                      paddingTop="0px"
                    ></Grid>
                  </Grid>
                  <Grid className="paper top-space">
                    <Paper elevation={4} className="group-container">
                      <Grid
                        container
                        rowGap={1}
                        sx={{
                          marginBottom: "10px",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* <h5>User Group</h5> */}
                        <AsyncSelect
                          placeholder={"User Group"}
                          defaultOptions={userGroupList.map((vall: any) => {
                            return { ...vall, value: vall.label };
                          })}
                          styles={customStyles}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: "#25258f",
                              primary25: "#ecebef",
                              primary50: "#e1dfea",
                            },
                          })}
                          onChange={(e: any) => {
                            handleChangeUserGroup(e);
                          }}
                        />

                        {userGroup.id > 0 ? (
                          <Button variant="outlined" onClick={handleAllSelect}>
                            {isAllCollapsOpen ? "Expand" : "collapse"}
                          </Button>
                        ) : (
                          <></>
                        )}
                      </Grid>

                      {/* NEW: Tabs for System Access / Buyer / Supplier / Product */}
                      {userGroup.id > 0 && (
                        <>
                        <Tabs
                          value={accessTabValue}
                          onChange={handleAccessTabChange}
                          variant="scrollable"
                          scrollButtons="auto"
                          indicatorColor="primary"
                          TabIndicatorProps={{ sx: { backgroundColor: " #2e67a3" } }}
                          sx={{
                            maxWidth: "100%",
                            marginBottom: "10px",
                            "& button:hover": {
                              backgroundColor: "#f1f6fe",
                              borderTopLeftRadius: "10px",
                              borderTopRightRadius: "10px",
                            },
                          }}
                        >
                          <Tab
                            sx={{ textTransform: "capitalize !important" }}
                            label="System Access"
                          />
                          <Tab
                            sx={{ textTransform: "capitalize !important" }}
                            label="Buyer"
                          />
                          <Tab
                            sx={{ textTransform: "capitalize !important" }}
                            label="Supplier"
                          />
                          <Tab
                            sx={{ textTransform: "capitalize !important" }}
                            label="Product"
                          />
                          <Tab
                            sx={{ textTransform: "capitalize !important" }}
                            label="Product Company"  
                          />
                        </Tabs>
                        <Box
                          sx={{
                            width: "100%",
                            borderBottom: "1px solid #ddd",
                          }}
                        />
                      </>
                      )}

                      {accessTabValue === 0 && (
                        <Grid container rowGap={1} className="search-space">
                          {userGroup.id > 0 ? (
                            <List
                              component="div"
                              disablePadding
                              sx={{ width: "100%" }}
                            >
                              {parent !== undefined &&
                                parent.map((item: any, mainIndex: any) => (
                                  <>
                                    <Box key={mainIndex}>
                                      <ListItemButton
                                        sx={{
                                          borderBottom: "1px solid #e9e9ef",
                                          "&:hover": {
                                            backgroundColor: "#f1f6fe",
                                          },
                                          height: "40px",
                                        }}
                                      >
                                        {resultData.some(
                                          (value) =>
                                            item.displayOrder + 0.1 ===
                                            value.displayOrder
                                        ) ? (
                                          <>
                                            {icon[mainIndex] ||
                                              !isAllCollapsOpen ? (
                                              <ExpandLess
                                                onClick={() =>
                                                  handleToggleCollapse(mainIndex)
                                                }
                                              />
                                            ) : (
                                              <ExpandMore
                                                onClick={() =>
                                                  handleToggleCollapse(mainIndex)
                                                }
                                              />
                                            )}
                                          </>
                                        ) : (
                                          <Box width={"25px"}></Box>
                                        )}

                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: !phone ? "200px" : "150px",
                                          }}
                                        >
                                          <Checkbox
                                            // checked={viewAccess[mainIndex]}
                                            checked={item.hasViewAccess}
                                            name={`menus.${mainIndex}.hasViewAccess`}
                                            onChange={(e) => {
                                              handleViewAccessOnly(
                                                e,
                                                item.code,
                                                mainIndex
                                              );
                                            }}
                                          />
                                          <Typography sx={{ fontWeight: 700 }}>
                                            {item.name}
                                          </Typography>
                                        </Box>

                                        {item.code ===
                                          "CLIENT_ADMIN_DASHBOARD" ? (
                                          <></>
                                        ) : (
                                          <>
                                            <Box sx={{ width: "100px" }}>
                                              <Typography>
                                                {fullControl[mainIndex]
                                                  ? "Full Control"
                                                  : readWrite[mainIndex]
                                                    ? "Read Write"
                                                    : null}{" "}
                                              </Typography>
                                            </Box>
                                            {item.code === "REPORT" ? (
                                              <></>
                                            ) : (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <Checkbox
                                                  // checked={readWrite[mainIndex]}
                                                  checked={item.hasInsertAccess}
                                                  onChange={(e) => {
                                                    handleReadWriteOnly(
                                                      e,
                                                      item.code,
                                                      mainIndex
                                                    );
                                                  }}
                                                />
                                                <Typography
                                                  sx={{ fontWeight: 700 }}
                                                >
                                                  Read Write
                                                </Typography>
                                              </Box>
                                            )}
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Checkbox
                                                // checked={fullControl[mainIndex]}
                                                checked={item.hasExportAccess}
                                                onChange={(e) => {
                                                  handleFullControl(
                                                    e,
                                                    item.code,
                                                    mainIndex
                                                  );
                                                }}
                                              />
                                              <Typography
                                                sx={{ fontWeight: 700 }}
                                              >
                                                Full Control
                                              </Typography>
                                            </Box>
                                          </>
                                        )}
                                      </ListItemButton>
                                    </Box>
                                    {values.map(
                                      (child: any, index: any) =>
                                        item.code === child.parentMenuCode && (
                                          <Collapse
                                            in={openCollapse[mainIndex]}
                                            timeout="auto"
                                            unmountOnExit
                                            sx={{
                                              marginLeft: !phone && "50px",
                                            }}
                                          >
                                            <TableContainer>
                                              <Table
                                                aria-labelledby="tableTitle"
                                                sx={{
                                                  "& .MuiTableCell-sizeMedium": {
                                                    padding: "0px 0px !important",
                                                  },
                                                }}
                                              >
                                                <>
                                                  {child.displayOrder ===
                                                    item.displayOrder + 0.1 &&
                                                    (child.parentMenuCode !==
                                                      "REPORT" ? (
                                                      <TableHead>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Menu
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            View
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Add
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Update
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Delete
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Import
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Export
                                                          </Typography>
                                                        </TableCell>
                                                      </TableHead>
                                                    ) : (
                                                      <TableHead>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Menu
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            View
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Typography
                                                            sx={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            Export
                                                          </Typography>
                                                        </TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                      </TableHead>
                                                    ))}
                                                  <TableBody>
                                                    {child.parentMenuCode !==
                                                      "REPORT" ? (
                                                      <TableRow>
                                                        <TableCell width="15%">
                                                          <Box
                                                            sx={{
                                                              display: "flex",
                                                              alignItems: "center",
                                                            }}
                                                          >
                                                            {/* NEW: chevron only shown when this row has its own sub-items (grandchildren) in resultData */}
                                                            {resultData.some(
                                                              (v: any) =>
                                                                v.parentMenuCode === child.code
                                                            ) ? (
                                                              reportIcon[`${mainIndex}-${child.code}`] ? (
                                                                <ExpandLess
                                                                  fontSize="small"
                                                                  sx={{ cursor: "pointer", mr: 0.5 }}
                                                                  onClick={() =>
                                                                    handleToggleReportCollapse(
                                                                      `${mainIndex}-${child.code}`
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <ExpandMore
                                                                  fontSize="small"
                                                                  sx={{ cursor: "pointer", mr: 0.5 }}
                                                                  onClick={() =>
                                                                    handleToggleReportCollapse(
                                                                      `${mainIndex}-${child.code}`
                                                                    )
                                                                  }
                                                                />
                                                              )
                                                            ) : (
                                                              <Box width="20px" />
                                                            )}
                                                            <Typography
                                                              sx={{
                                                                fontSize:
                                                                  phone2 &&
                                                                  "10px !important",
                                                              }}
                                                            >
                                                              {child.name}
                                                            </Typography>
                                                          </Box>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasViewAccess`}
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasViewAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );
                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasViewAccess",
                                                                e,
                                                                child.parentMenuCode,
                                                                item.code,
                                                                child.name // children node name
                                                              );
                                                            }}
                                                            checked={
                                                              child.hasViewAccess
                                                            }
                                                          />
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasInsertAccess`}
                                                            checked={
                                                              child.hasInsertAccess
                                                            }
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasInsertAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );

                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasInsertAccess",
                                                                e
                                                              );
                                                            }}
                                                          />
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasUpdateAccess`}
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasUpdateAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );
                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasUpdateAccess",
                                                                e
                                                              );
                                                            }}
                                                            checked={
                                                              child.hasUpdateAccess
                                                            }
                                                          />
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasDeleteAccess`}
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasDeleteAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );
                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasDeleteAccess",
                                                                e
                                                              );
                                                            }}
                                                            checked={
                                                              child.hasDeleteAccess
                                                            }
                                                          />
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasImportAccess`}
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasImportAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );
                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasImportAccess",
                                                                e
                                                              );
                                                            }}
                                                            checked={
                                                              child.hasImportAccess
                                                            }
                                                          />
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasExportAccess`}
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasExportAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );
                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasExportAccess",
                                                                e
                                                              );
                                                            }}
                                                            checked={
                                                              child.hasExportAccess
                                                            }
                                                          />
                                                        </TableCell>
                                                      </TableRow>
                                                    ) : (
                                                      <TableRow>
                                                        <TableCell width="15%">
                                                          <Box
                                                            sx={{
                                                              display: "flex",
                                                              alignItems: "center",
                                                            }}
                                                          >
                                                            {/* NEW: chevron only shown when this report row has its own sub-items (grandchildren) in resultData */}
                                                            {resultData.some(
                                                              (v: any) =>
                                                                v.parentMenuCode === child.code
                                                            ) ? (
                                                              reportIcon[`${mainIndex}-${child.code}`] ? (
                                                                <ExpandLess
                                                                  fontSize="small"
                                                                  sx={{ cursor: "pointer", mr: 0.5 }}
                                                                  onClick={() =>
                                                                    handleToggleReportCollapse(
                                                                      `${mainIndex}-${child.code}`
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <ExpandMore
                                                                  fontSize="small"
                                                                  sx={{ cursor: "pointer", mr: 0.5 }}
                                                                  onClick={() =>
                                                                    handleToggleReportCollapse(
                                                                      `${mainIndex}-${child.code}`
                                                                    )
                                                                  }
                                                                />
                                                              )
                                                            ) : (
                                                              <Box width="20px" />
                                                            )}
                                                            <Typography
                                                              sx={{
                                                                fontSize:
                                                                  phone2 &&
                                                                  "10px !important",
                                                              }}
                                                            >
                                                              {child.name}
                                                            </Typography>
                                                          </Box>
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasViewAccess`}
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasViewAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );
                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasViewAccess",
                                                                e,
                                                                child.parentMenuCode,
                                                                item.code,
                                                                child.name // children node name
                                                              );
                                                            }}
                                                            checked={
                                                              child.hasViewAccess
                                                            }
                                                          />
                                                        </TableCell>
                                                        <TableCell width="15%">
                                                          <Checkbox
                                                            name={`${item}.${index}.hasExportAccess`}
                                                            onChange={(e) => {
                                                              handlePropsChange(
                                                                e,
                                                                index,
                                                                "hasExportAccess",
                                                                child.parentMenuCode,
                                                                mainIndex
                                                              );
                                                              handlePropsUpdate(
                                                                child.displayOrder,
                                                                child.menuId,
                                                                "hasExportAccess",
                                                                e
                                                              );
                                                            }}
                                                            checked={
                                                              child.hasExportAccess
                                                            }
                                                          />
                                                        </TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                        <TableCell width="15%"></TableCell>
                                                      </TableRow>
                                                    )}

                                                    {/* NEW: nested sub-item row (3rd level) — only rendered when this row has grandchildren in resultData */}
                                                    {resultData.some(
                                                      (v: any) => v.parentMenuCode === child.code
                                                    ) && (
                                                        <TableRow>
                                                          <TableCell
                                                            style={{ paddingBottom: 0, paddingTop: 0 }}
                                                            colSpan={7}
                                                          >
                                                            <Collapse
                                                              in={!!reportCollapse[`${mainIndex}-${child.code}`]}
                                                              timeout="auto"
                                                              unmountOnExit
                                                            >
                                                              <Box
                                                                sx={{
                                                                  marginLeft: !phone ? "25px" : "15px",
                                                                  marginY: 0.5,
                                                                }}
                                                              >
                                                                <Table
                                                                  size="small"
                                                                  sx={{
                                                                    "& .MuiTableCell-root": {
                                                                      padding: "4px 8px !important",
                                                                    },
                                                                  }}
                                                                >
                                                                  <TableHead>
                                                                    <TableRow>
                                                                      <TableCell width="15%">
                                                                        <Typography sx={{ fontWeight: 600 }}>
                                                                          Sub Report
                                                                        </Typography>
                                                                      </TableCell>
                                                                      <TableCell width="15%">
                                                                        <Typography sx={{ fontWeight: 600 }}>
                                                                          View
                                                                        </Typography>
                                                                      </TableCell>
                                                                      <TableCell width="15%">
                                                                        <Typography sx={{ fontWeight: 600 }}>
                                                                          Export
                                                                        </Typography>
                                                                      </TableCell>
                                                                      <TableCell width="15%"></TableCell>
                                                                      <TableCell width="15%"></TableCell>
                                                                      <TableCell width="15%"></TableCell>
                                                                      <TableCell width="15%"></TableCell>
                                                                    </TableRow>
                                                                  </TableHead>
                                                                  <TableBody>
                                                                    {resultData
                                                                      .filter(
                                                                        (v: any) =>
                                                                          v.parentMenuCode === child.code
                                                                      )
                                                                      .map((grandchild: any) => {
                                                                        const gIndex = resultData.findIndex(
                                                                          (v: any) =>
                                                                            v.menuId === grandchild.menuId
                                                                        );
                                                                        return (
                                                                          <TableRow key={grandchild.menuId}>
                                                                            <TableCell width="15%">
                                                                              <Typography
                                                                                sx={{
                                                                                  fontSize:
                                                                                    phone2 &&
                                                                                    "10px !important",
                                                                                }}
                                                                              >
                                                                                {grandchild.name}
                                                                              </Typography>
                                                                            </TableCell>
                                                                            <TableCell width="15%">
                                                                              <Checkbox
                                                                                size="small"
                                                                                checked={grandchild.hasViewAccess}
                                                                                onChange={(e) =>
                                                                                  handlePropsChange(
                                                                                    e,
                                                                                    gIndex,
                                                                                    "hasViewAccess",
                                                                                    grandchild.parentMenuCode,
                                                                                    mainIndex
                                                                                  )
                                                                                }
                                                                              />
                                                                            </TableCell>
                                                                            <TableCell width="15%">
                                                                              <Checkbox
                                                                                size="small"
                                                                                checked={grandchild.hasExportAccess}
                                                                                onChange={(e) =>
                                                                                  handlePropsChange(
                                                                                    e,
                                                                                    gIndex,
                                                                                    "hasExportAccess",
                                                                                    grandchild.parentMenuCode,
                                                                                    mainIndex
                                                                                  )
                                                                                }
                                                                              />
                                                                            </TableCell>
                                                                            <TableCell width="15%"></TableCell>
                                                                            <TableCell width="15%"></TableCell>
                                                                            <TableCell width="15%"></TableCell>
                                                                            <TableCell width="15%"></TableCell>
                                                                          </TableRow>
                                                                        );
                                                                      })}
                                                                  </TableBody>
                                                                </Table>
                                                              </Box>
                                                            </Collapse>
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                  </TableBody>
                                                </>
                                              </Table>
                                            </TableContainer>
                                          </Collapse>
                                        )
                                    )}
                                  </>
                                ))}
                            </List>
                          ) : (
                            <Box className="user-group-not-selected">
                              <Typography>User group is not selected.</Typography>
                            </Box>
                          )}
                        </Grid>
                      )}

  {accessTabValue === 1 && (
  <Box sx={{ p: 2 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 2,
      }}
    >
      <Typography sx={{ fontWeight: 600, color: "#25258f" }}>
        Buyer Access
      </Typography>
      <IconButton
        size="small"
        onClick={() => handleOpenSelectPopup("buyer")}
        sx={{
          border: "1px #25258f",
          color: "#25258f",
          borderRadius: "50%",
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
    
    {/* VERTICAL LIST */}
    <Paper
      variant="outlined"
      sx={{
        width: "60%",
        maxHeight: 300,
        overflow: "auto",
        p: 1,
      }}
    >
      {selectedBuyers.length === 0 ? (
        <Typography variant="body2" sx={{ color: "#999", p: 1 }}>
          No buyers selected.
        </Typography>
      ) : (
        <List sx={{ p: 0 }}>
          {selectedBuyers.map((item: any) => (
            <ListItem
              key={item.value}
              secondaryAction={
                <IconButton 
                  edge="end" 
                  size="small"
                  onClick={() => handleRemoveSelectedItem("buyer", item)}
                >
                  <ClearIcon fontSize="small" sx={{ color: "red" }} />
                </IconButton>
              }
              sx={{
                borderBottom: "1px solid #e0e0e0",
                py: 1,
              }}
            >
              <ListItemText 
                primary={item.organizationName || item.buyerName || item.label}
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  </Box>
)}
{accessTabValue === 2 && (
  <Box sx={{ p: 2 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 2,
      }}
    >
      <Typography sx={{ fontWeight: 600, color: "#25258f" }}>
        Supplier Access
      </Typography>
      <IconButton
        size="small"
        onClick={() => handleOpenSelectPopup("supplier")}
        sx={{
          border: "1px  #25258f",
          color: "#25258f",
          borderRadius: "50%",
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
    
    {/* VERTICAL LIST */}
    <Paper
      variant="outlined"
      sx={{
        width: "60%",
        maxHeight: 300,
        overflow: "auto",
        p: 1,
      }}
    >
      {selectedSuppliers.length === 0 ? (
        <Typography variant="body2" sx={{ color: "#999", p: 1 }}>
          No suppliers selected.
        </Typography>
      ) : (
        <List sx={{ p: 0 }}>
          {selectedSuppliers.map((item: any) => (
            <ListItem
              key={item.value}
              secondaryAction={
                <IconButton 
                  edge="end" 
                  size="small"
                  onClick={() => handleRemoveSelectedItem("supplier", item)}
                >
                  <ClearIcon fontSize="small" sx={{ color: "red" }} />
                </IconButton>
              }
              sx={{
                borderBottom: "1px solid #e0e0e0",
                py: 1,
              }}
            >
              <ListItemText 
                primary={item.organizationName || item.supplierName || item.label}
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  </Box>
)}
{accessTabValue === 3 && (
  <Box sx={{ p: 2 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 2,
      }}
    >
      <Typography sx={{ fontWeight: 600, color: "#25258f" }}>
        Product Access
      </Typography>
      <IconButton
        size="small"
        onClick={() => handleOpenSelectPopup("product")}
        sx={{
          border: "1px  #25258f",
          color: "#25258f",
          borderRadius: "50%",
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
    
    {/* VERTICAL LIST */}
    <Paper
      variant="outlined"
      sx={{
        width: "60%",
        maxHeight: 300,
        overflow: "auto",
        p: 1,
      }}
    >
      {selectedProducts.length === 0 ? (
        <Typography variant="body2" sx={{ color: "#999", p: 1 }}>
          No products selected.
        </Typography>
      ) : (
        <List sx={{ p: 0 }}>
          {selectedProducts.map((item: any) => (
            <ListItem
              key={item.value}
              secondaryAction={
                <IconButton 
                  edge="end" 
                  size="small"
                  onClick={() => handleRemoveSelectedItem("product", item)}
                >
                  <ClearIcon fontSize="small" sx={{ color: "red" }} />
                </IconButton>
              }
              sx={{
                borderBottom: "1px solid #e0e0e0",
                py: 1,
              }}
            >
              <ListItemText 
                primary={item.productName || item.label}
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  </Box>
)}
{accessTabValue === 4 && (  // ⭐ Product Company Tab (index 4)
  <Box sx={{ p: 2 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 2,
      }}
    >
      <Typography sx={{ fontWeight: 600, color: "#25258f" }}>
        Product Company Access
      </Typography>
      <IconButton
        size="small"
        onClick={() => handleOpenSelectPopup("productCompany")}
        sx={{
          border: "1px #25258f",
          color: "#25258f",
          borderRadius: "50%",
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
    
    <Paper
      variant="outlined"
      sx={{
        width: "60%",
        maxHeight: 300,
        overflow: "auto",
        p: 1,
      }}
    >
      {selectedProductCompanies.length === 0 ? (
        <Typography variant="body2" sx={{ color: "#999", p: 1 }}>
          No product companies selected.
        </Typography>
      ) : (
        <List sx={{ p: 0 }}>
          {selectedProductCompanies.map((item: any) => (
            <ListItem
              key={item.value}
              secondaryAction={
                <IconButton 
                  edge="end" 
                  size="small"
                  onClick={() => handleRemoveSelectedItem("productCompany", item)}
                >
                  <ClearIcon fontSize="small" sx={{ color: "red" }} />
                </IconButton>
              }
              sx={{
                borderBottom: "1px solid #e0e0e0",
                py: 1,
              }}
            >
              <ListItemText 
                primary={item.productCompanyName || item.name || item.label}
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  </Box>
)}
                    </Paper>
                  </Grid>
                </Grid>
              ) : (
                <MissingConsumer consumerId={userContext.consumerId} />
              )}
            </Box>

            {userGroup.id > 0 ? (
              <Grid
                container
                columnSpacing={2}
                rowSpacing={2}
                className="GridMobileView"
                paddingY={2}
                zIndex={90}
              >
                <Grid item xs={6} textAlign="right">
                  <LoadingButton
                    color="primary"
                    type="submit"
                    loading={isSubmitLoading}
                    variant="contained"
                  >
                    Submit
                  </LoadingButton>
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
          </Form>
        )}
      </Formik>

      {/* ===== UPDATED: shared "+" button popup with PAGINATION (Like BuyerSave) ===== */}
{(() => {
  const activeConfig = getPopupConfig(selectPopup.type);

  // Get filtered items based on search
  const allFilteredItems = (activeConfig.allItems || []).filter((item: any) =>
    item.label?.toLowerCase().includes(selectPopupSearch.toLowerCase())
  );

  // Calculate pagination
  const startIndex = (selectPopupPage - 1) * selectPopupPageSize;
  const endIndex = Math.min(startIndex + selectPopupPageSize, allFilteredItems.length);
  const filteredList = allFilteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(allFilteredItems.length / selectPopupPageSize);

  // Check if all items on current page are selected
  const allFilteredChecked =
    filteredList.length > 0 &&
    filteredList.every((item: any) =>
      stagedSelection.some((x) => x.value === item.value)
    );

  return (
    <Dialog
      open={selectPopup.open}
      onClose={handleCloseSelectPopup}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          minWidth: phone ? "100%" : "700px",
          width: phone ? "100%" : "auto",
          m: phone ? 0 : 2,
        },
      }}
    >
      {/* Header - Like BuyerSave */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: phone ? "flex-start" : "center",
          flexDirection: phone ? "column" : "row",
          gap: phone ? 1 : 0,
          p: 2,
          pb: 0,
        }}
      >
        <h4 className="page-title" style={{ margin: 0 }}>
          {activeConfig.title}
        </h4>
        <IconButton
          onClick={handleCloseSelectPopup}
          sx={{ alignSelf: phone ? "flex-end" : "center" }}
        >
          <ClearIcon sx={{ color: "red" }} />
        </IconButton>
      </Box>

      <DialogContent>
        {/* Search - Like BuyerSave */}
        <Grid container>
          <Grid item xs={12}>
            <TextField
              autoFocus
              size="small"
              fullWidth
              placeholder="Search..."
              value={selectPopupSearch}
              onChange={(e) => {
                setSelectPopupSearch(e.target.value);
                setSelectPopupPage(1);
              }}
              sx={{ mb: 2 }}
            />
          </Grid>
        </Grid>

        {/* Table - Like BuyerSave */}
        <TableContainer
          component={Paper}
          variant="outlined"
          className="popup-table-container"
          sx={{
            width: "100%",
            maxHeight: phone ? "60vh" : "400px",
            overflow: "auto",
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
                <TableRow>
                  <TableCell padding="checkbox" sx={{ width: "50px" }}>
                    <Checkbox
                      checked={allFilteredChecked}
                      onChange={(e) =>
                        handleSelectAllInPopup(
                          filteredList,
                          e.target.checked,
                          allFilteredItems
                        )
                      }
                      color="primary"
                      title="Select all items on this page"
                    />
                  </TableCell>

                  <TableCell sx={{ fontWeight: "bold" }}>
                    Name
                  </TableCell>
                </TableRow>

                {showSelectAllPrompt && (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 1,
                          py: 0.5,
                        }}
                      >
                        {stagedSelection.length ===
                        selectAllPromptItems.length ? (
                          <>
                            <Typography sx={{ fontSize: 13 }}>
                              All {selectAllPromptItems.length}{" "}
                              {activeConfig.title
                                .replace("Select ", "")
                                .toLowerCase()}{" "}
                              are selected.
                            </Typography>

                            <Button
                              variant="text"
                              size="small"
                              onClick={() => {
                                setStagedSelection([]);
                                setShowSelectAllPrompt(false);
                                setSelectAllPromptItems([]);
                              }}
                              sx={{
                                minWidth: "auto",
                                padding: 0,
                                fontSize: 13,
                              }}
                            >
                              Clear selection
                            </Button>
                          </>
                        ) : (
                          <>
                            <Typography sx={{ fontSize: 13 }}>
                              All {filteredList.length}{" "}
                              {activeConfig.title
                                .replace("Select ", "")
                                .toLowerCase()}{" "}
                              on this page are selected.
                            </Typography>

                            <Button
                              variant="text"
                              size="small"
                              onClick={() => {
                                setStagedSelection([
                                  ...selectAllPromptItems,
                                ]);
                              }}
                              sx={{
                                minWidth: "auto",
                                padding: 0,
                                fontSize: 13,
                              }}
                            >
                              Select all {selectAllPromptItems.length}{" "}
                              {activeConfig.title
                                .replace("Select ", "")
                                .toLowerCase()}
                            </Button>
                          </>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableHead>
            <TableBody>
              {filteredList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2} align="center" sx={{ py: 3 }}>
                    <Typography sx={{ color: "gray", fontSize: 13 }}>
                      No records found.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredList.map((item: any) => {
                  const isChecked = stagedSelection.some(
                    (x) => x.value === item.value
                  );
                  return (
                    <TableRow
                      key={item.value}
                      hover
                      selected={isChecked}
                      onClick={() => handleToggleSelectItem(item)}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox checked={isChecked} color="primary" />
                      </TableCell>
                      <TableCell sx={{ fontSize: 13 }}>{item.label}</TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ===== PAGINATION CONTROLS - Like BuyerSave ===== */}
        {allFilteredItems.length > selectPopupPageSize && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
              mb: 2,
              px: 1,
            }}
          >
            <Typography sx={{ fontSize: 12, color: "gray" }}>
              {(selectPopupPage - 1) * selectPopupPageSize + 1} -{" "}
              {Math.min(
                selectPopupPage * selectPopupPageSize,
                allFilteredItems.length
              )}{" "}
              of {allFilteredItems.length}
            </Typography>
            <Pagination
              count={totalPages}
              page={selectPopupPage}
              onChange={(event, page) => {
                setSelectPopupPage(page);
                const tableContainer = document.querySelector('.popup-table-container');
                if (tableContainer) {
                  tableContainer.scrollTop = 0;
                }
              }}
              size={phone ? "small" : "medium"}
            />
          </Box>
        )}
      </DialogContent>

      {/* Footer - Like BuyerSave */}
      <Box
        sx={{
          display: "flex",
          flexDirection: phone ? "column" : "row",
          justifyContent: "space-between",
          alignItems: phone ? "flex-start" : "center",
          gap: phone ? 2 : 0,
          p: 2,
          pt: 1,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Typography sx={{ fontSize: 13, color: "gray" }}>
          {stagedSelection.length} item(s) selected
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: phone ? "100%" : "auto",
            justifyContent: phone ? "space-between" : "flex-end",
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCloseSelectPopup}
            fullWidth={phone}
          >
            <ShortcutButton label="ESC" />
            Cancel
          </Button>
          <Button
            ref={saveButtonRef}
            variant="contained"
            color="primary"
            onClick={handleSaveSelectPopup}
            fullWidth={phone}
          >
            <ShortcutButton label="F10" variant="dark" />
            Save
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
})()}
    </>
  );
}

const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
  }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};